import { createConfig, lazyRoute } from "../config/config-utils"

const AccountApp = lazyRoute(()=> import("./AccountApp"), "AccountApp")

export const ACCOUNT_CONFIG = createConfig({
  component: AccountApp,
  key: "account",
  label: "Account",
})
